import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  counter-reset: number;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
import Box from "../layout/Box";
var OrderedList = styled(Box).attrs({
    as: "ol"
}).withConfig({
    componentId: "sc-18d8aa3e-0"
})(_templateObject(), function(param) {
    var theme = param.theme, $variant = param.$variant;
    return $variant && theme.expandVariants($variant, theme.typography.lists.ordered);
});
OrderedList.displayName = "OrderedList";
export default OrderedList;
